<script lang="ts">
  import type { StyleValue } from 'vue'
  import { defineComponent, computed } from 'vue'
  import { getNamespace } from '../../../utils/global-config'
  import { addUnit } from '../../../shared/utils'

  export default defineComponent({
    name: 'BnIconAppPc',
    props: {
      size: {
        type: [Number, String],
        default: undefined
      },
      rotate: {
        type: Number,
        default: undefined
      },
      spin: {
        type: Boolean,
        default: false
      },
      color: {
        type: String,
        default: undefined
      }
    },
    setup(props) {
      const ns = getNamespace('icon')

      const styles = computed(() => {
        const styles: StyleValue = {}
        if (props.size) {
          styles.fontSize = addUnit(props.size)
        }

        if (props.rotate) {
          styles.transform = `rotate(${props.rotate}deg)`
        }

        if (props.color) {
          styles.color = props.color
        }
        return styles
      })

      const cls = computed(() => [
        ns,
        {
          [`${ns}-loading`]: props.spin
        }
      ])

      return {
        cls,
        styles
      }
    }
  })
</script>

<template>
  <i :class="cls" :style="styles">
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>编组 16</title>
      <g id="抓潜拓客" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g
          id="菜单图标"
          transform="translate(-200.000000, -368.000000)"
          fill="#9CA6B9"
          fill-rule="nonzero"
        >
          <g id="编组-16" transform="translate(200.000000, 368.000000)">
            <path
              id="矩形"
              d="M18,4 C19.1045695,4 20,4.8954305 20,6 L20,15 C20,16.1045695 19.1045695,17 18,17 L6,17 C4.8954305,17 4,16.1045695 4,15 L4,6 C4,4.8954305 4.8954305,4 6,4 L18,4 Z M18,5.6 L6,5.6 C5.80670034,5.6 5.64542508,5.7371128 5.60812658,5.91938605 L5.6,6 L5.6,15 C5.6,15.1932997 5.7371128,15.3545749 5.91938605,15.3918734 L6,15.4 L18,15.4 C18.1932997,15.4 18.3545749,15.2628872 18.3918734,15.080614 L18.4,15 L18.4,6 C18.4,5.80670034 18.2628872,5.64542508 18.080614,5.60812658 L18,5.6 Z"
            ></path>
            <polygon
              id="路径-3"
              transform="translate(15.065720, 7.831746) rotate(-0.000000) translate(-15.065720, -7.831746) "
              points="16.0657196 7.03174595 16.0657196 8.63174595 14.0657196 8.63174595 14.0657196 7.03174595"
            ></polygon>
            <polygon id="路径-3" points="20 18.7 20 20.3 4 20.3 4 18.7"></polygon>
          </g>
        </g>
      </g>
    </svg>
  </i>
</template>
